import {Box, Grid} from '@primer/react-brand/esm'

import {hpcAttrs} from '@github-ui/hpc'
import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import {ContentfulCtaBanner} from '@github-ui/swp-core/components/contentful/ContentfulCtaBanner'
import {useContentfulData} from '@github-ui/swp-core/lib/hooks/use-contentful-data'

import {BreadcrumbsList} from '../components/BreadcrumbsList/BreadcrumbsList'
import RelatedResources from '../components/RelatedResources/RelatedResources'
import {toConfirmationPage, toEntryCollection} from '../lib/types/contentful'
import {toResourceConfirmationPayload} from '../lib/types/payload'

export const ConfirmationPage = () => {
  const {contentfulRawJsonResponse, breadcrumbLinks} = toResourceConfirmationPayload(useRoutePayload<unknown>())
  const contentfulData = useContentfulData(contentfulRawJsonResponse)
  const page = toConfirmationPage(toEntryCollection(contentfulData).at(0))
  const {template} = page.fields
  const {ctaBanner, relatedResources} = template.fields

  const breadcrumbs =
    breadcrumbLinks?.map(link => ({
      name: link.name,
      url: link.href,
    })) || []

  return (
    <>
      <Grid>
        <Grid.Column>
          {breadcrumbs.length > 0 ? (
            <Box marginBlockStart={20} marginBlockEnd={24}>
              <BreadcrumbsList items={breadcrumbs} />
            </Box>
          ) : null}

          {ctaBanner ? (
            <div {...hpcAttrs()}>
              <ContentfulCtaBanner component={ctaBanner} />
            </div>
          ) : null}
        </Grid.Column>
      </Grid>

      {relatedResources && relatedResources.length > 0 && (
        <Grid className="tmp-mt-5 tmp-mt-lg-9 tmp-mb-5 tmp-mb-lg-10">
          <Grid.Column>
            <RelatedResources relatedResources={relatedResources} />
          </Grid.Column>
        </Grid>
      )}
    </>
  )
}
